import { Navigate } from "react-router-dom";
import { getAuthToken } from "../commons/AuthTokenUtils";

export const AlreadyLoggedInRoute = (props: { children: any }) => {
  if (getAuthToken()) {
    return <Navigate to="/" />;
  }
  return props.children;
};
